/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:13/02/2021
 @Time:08:50
 **/
import PaiementLigneBase from "./PaiementLigneBase";

export default class PaiementLigneEspece extends PaiementLigneBase
{


    constructor() {
        super();
        super.discriminator="espece";
    }

    static createFromJson(paiementLigneJson,paiementLigneBase){
        let paiementLigneEspece=new PaiementLigneEspece();
        super.createFromJson(paiementLigneJson,paiementLigneEspece);
        return paiementLigneEspece;
    }

}